// src/com/dc_and_store/DcAndStore.js
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import DcInfo from '../dc_info/DcInfo';
import ArriveInfo from '../arrive_info/ArriveInfo';
import ComInfo from '../com_info/ComInfo';
import { AppMenuUrl } from '../../value/AppConst';

export default function DcAndStore({
    menu, parentMenu
}) {
    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    // 출발지, 도착지, 운송사 정보
    return(
        <TopViewControl>
            {
                (() => {
                    if(menu.menuUrl===AppMenuUrl.DCInfo) return <DcInfo viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.ArriveInfo) return <ArriveInfo viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.ComInfo) return <ComInfo viewServiceTags={viewServiceTags} />;
                    return null;
                })()
            }
        </TopViewControl>
    );
}